import { Flex, Space, Tooltip, Typography } from "antd"

import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"
import { formatCurrency } from "../../../../Utils/utils"

import "./styles.less"

const { Text } = Typography

const InfoTooltip = () => (
  <Tooltip
    overlayClassName="referral-reward-info-tooltip-container"
    title={
      "The reward is given only for alerts that have been paid. Referral bonuses are not included here."
    }
  >
    <div>
      <Icon className="info-icon" type="circle_info" />
    </div>
  </Tooltip>
)

const OverviewTotalReward = ({
  count,
  reward,
  style,
  title,
  tooltip,
  withoutTooltip,
  isMobile
}) => {
  return (
    <Flex style={style} gap={!isMobile ? 26 : 12} vertical className="overview-total-reward">
      <Text strong>{title}</Text>
      <Flex gap={40}>
        <Flex gap={8} vertical>
          <Space size={4} align="center">
            <Text type="secondary">Count</Text>
          </Space>
          <Text className="total-number">
            <Private>{count}</Private>
          </Text>
        </Flex>
        <Flex gap={8} vertical>
          <Space size={4} align="center">
            <Text type="secondary">Reward</Text>
            {!withoutTooltip && <InfoTooltip />}
          </Space>
          <Text className="total-number">
            <Private>{formatCurrency(reward / 100)}</Private>
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default OverviewTotalReward
